// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","791":"ee9ce975"}[chunkId] || chunkId) + "-" + {"27":"b54751e88397ffc26ec8","245":"e5c8723f417e6885b986","453":"ee3f09bffc2fc92f3840","791":"de3928ccceb1a99e51b4"}[chunkId] + ".js";
};